import React from "react";

type MobileBatchChromeContextValue = {
  unifiedHeaderActive: boolean;
  setUnifiedHeaderActive: (active: boolean) => void;
};

export const MobileBatchChromeContext = React.createContext<MobileBatchChromeContextValue>({
  unifiedHeaderActive: false,
  setUnifiedHeaderActive: () => {},
});

export function useMobileBatchChrome() {
  return React.useContext(MobileBatchChromeContext);
}
